import { render } from "./ClientReportesClientesDeuda.vue?vue&type=template&id=37810be5&scoped=true"
import script from "./ClientReportesClientesDeuda.vue?vue&type=script&lang=js"
export * from "./ClientReportesClientesDeuda.vue?vue&type=script&lang=js"

import "./ClientReportesClientesDeuda.vue?vue&type=style&index=0&id=37810be5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37810be5"]])

export default __exports__